module.exports = __webpack_public_path__ + "static/media/back.334e40b3.svg";